import { render, staticRenderFns } from "./Solution.vue?vue&type=template&id=5ef5a48c&scoped=true&"
import script from "./Solution.vue?vue&type=script&lang=ts&"
export * from "./Solution.vue?vue&type=script&lang=ts&"
import style0 from "./Solution.vue?vue&type=style&index=0&id=5ef5a48c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef5a48c",
  null
  
)

export default component.exports